import { base, type IIconProps } from './base';

interface IStrokeIconProps extends IIconProps {
  /** Override the shared 1.6 stroke — e.g. the dashboard card's hide control
      renders at 10px, where 1.6 is too faint to read as an X. */
  strokeWidth?: number;
}

export function PlusIcon({ size = 16, strokeWidth = base.strokeWidth }: IStrokeIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={strokeWidth}>
      <path d="M12 5v14"/>
      <path d="M5 12h14"/>
    </svg>
  )
}

export function TrashIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 6h18"/>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
  )
}

export function CheckIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M20 6 9 17l-5-5"/>
    </svg>
  )
}

export function CopyIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="9" y="9" width="13" height="13" rx="2"/>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
  )
}

export function ArrowRightIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M5 12h14"/>
      <path d="m12 5 7 7-7 7"/>
    </svg>
  )
}

export function ArrowUpRightIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M7 17 17 7" />
      <path d="M7 7h10v10" />
    </svg>
  )
}

export function AlignLeftIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 6H3" />
      <path d="M15 12H3" />
      <path d="M17 18H3" />
    </svg>
  )
}

export function AlignCenterIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 6H3" />
      <path d="M17 12H7" />
      <path d="M19 18H5" />
    </svg>
  )
}

export function AlignRightIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 6H3" />
      <path d="M21 12H9" />
      <path d="M21 18H7" />
    </svg>
  )
}

export function MousePointerIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12.586 12.586 19 19"/>
      <path d="M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z"/>
    </svg>
  )
}

export function EraserIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
      <path d="M22 21H7" />
      <path d="m5 11 9 9" />
    </svg>
  )
}

export function HighlighterIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m9 11-6 6v3h9l3-3" />
      <path d="m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4l8 8Z" />
    </svg>
  )
}

export function UndoIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
    </svg>
  )
}

export function RedoIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m15 14 5-5-5-5" />
      <path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13" />
    </svg>
  )
}

export function ZoomInIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
      <path d="M8 11h6" />
      <path d="M11 8v6" />
    </svg>
  )
}

export function ZoomOutIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
      <path d="M8 11h6" />
    </svg>
  )
}

export function LineIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M5 19 19 5" />
    </svg>
  )
}

export function SquareIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="4" y="4" width="16" height="16" rx="1.5" />
    </svg>
  )
}

export function TypeIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M5 5h14" />
      <path d="M12 5v14" />
      <path d="M9 19h6" />
    </svg>
  )
}

export function CloseIcon({ size = 16, strokeWidth = base.strokeWidth }: IStrokeIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={strokeWidth}>
      <path d="M18 6 6 18"/>
      <path d="m6 6 12 12"/>
    </svg>
  )
}

export function DownloadIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  )
}

export function UploadCloudIcon({ size = 24 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M16 16l-4-4-4 4" />
      <path d="M12 12v9" />
      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
      <path d="M16 16l-4-4-4 4" />
    </svg>
  )
}

export function WarningTriangleIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  )
}

export function FloorIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="4" width="18" height="6" rx="1"/>
      <rect x="3" y="14" width="18" height="6" rx="1"/>
    </svg>
  )
}

export function SearchIconSm({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="11" cy="11" r="7"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  )
}

export function ChevronRightIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M9 18l6-6-6-6"/>
    </svg>
  )
}

export function ChevronLeftIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M15 18l-6-6 6-6"/>
    </svg>
  )
}

export function PackageIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <path d="M3.27 6.96 12 12.01l8.73-5.05" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  );
}

export function PersonIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  );
}

export function ClockIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

export function FolderIconClosed({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
    </svg>
  );
}

export function FolderIconOpen({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M6 14l1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
    </svg>
  );
}

export function GitCompareIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="18" cy="18" r="3" />
      <circle cx="6" cy="6" r="3" />
      <path d="M13 6h3a2 2 0 0 1 2 2v7" />
      <path d="M11 18H8a2 2 0 0 1-2-2V9" />
    </svg>
  );
}

export function SortIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m21 16-4 4-4-4" />
      <path d="M17 20V4" />
      <path d="m3 8 4-4 4 4" />
      <path d="M7 4v16" />
    </svg>
  );
}

export function TagIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </svg>
  );
}

export function TagBadgeIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="3.25 2.75 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58621 4.25C7.14317 4.25 6.25 5.65264 6.25 7V17.5C6.25 18.8474 7.14317 20.25 8.58621 20.25H16.9138C18.3568 20.25 19.25 18.8474 19.25 17.5V7C19.25 5.65264 18.3568 4.25 16.9138 4.25H8.58621ZM7.75 7C7.75 6.13822 8.27716 5.75 8.58621 5.75H16.9138C17.2228 5.75 17.75 6.13822 17.75 7V17.5C17.75 18.3618 17.2228 18.75 16.9138 18.75H8.58621C8.27716 18.75 7.75 18.3618 7.75 17.5V7ZM9.75 7C9.33579 7 9 7.33579 9 7.75C9 8.16421 9.33579 8.5 9.75 8.5H15.75C16.1642 8.5 16.5 8.16421 16.5 7.75C16.5 7.33579 16.1642 7 15.75 7H9.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MapPinIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 21s7-6.75 7-12a7 7 0 0 0-14 0c0 5.25 7 12 7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  );
}

export function WrenchIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  );
}

export function FlagIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 21V4" />
      <path d="M4 4h13l-2.5 4 2.5 4H4" />
    </svg>
  );
}

/** Issue glyph, filled (Trusstor's `issues-filled`) — the issue chip's lead icon. */
export function IssueFilledIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 7.75C7.25 6.64543 8.14543 5.75 9.25 5.75H17.25C18.3546 5.75 19.25 6.64543 19.25 7.75V13.75C19.25 14.8546 18.3546 15.75 17.25 15.75H9.25C8.14543 15.75 7.25 14.8546 7.25 13.75V7.75ZM4.75 7C5.16421 7 5.5 7.33579 5.5 7.75V14.25C5.5 16.0449 6.95507 17.5 8.75 17.5H16.75C17.1642 17.5 17.5 17.8358 17.5 18.25C17.5 18.6642 17.1642 19 16.75 19H8.75C6.12665 19 4 16.8734 4 14.25V7.75C4 7.33579 4.33579 7 4.75 7ZM13.2426 7.92499C13.6568 7.92499 13.9926 8.26077 13.9926 8.67499V10.358C13.9926 10.7722 13.6568 11.108 13.2426 11.108C12.8284 11.108 12.4926 10.7722 12.4926 10.358V8.67499C12.4926 8.26077 12.8284 7.92499 13.2426 7.92499ZM13.2428 12.9618C13.298 12.9618 13.3287 12.9186 13.3287 12.8828C13.3287 12.847 13.298 12.8038 13.2428 12.8038C13.1876 12.8038 13.1569 12.847 13.1569 12.8828C13.1569 12.9186 13.1876 12.9618 13.2428 12.9618ZM12.3287 12.8828C12.3287 12.382 12.7302 11.9618 13.2428 11.9618C13.7555 11.9618 14.1569 12.382 14.1569 12.8828C14.1569 13.3836 13.7555 13.8038 13.2428 13.8038C12.7302 13.8038 12.3287 13.3836 12.3287 12.8828Z"
      />
    </svg>
  );
}

/** Outline flag (Trusstor's `flag`) — marks something past its due date. */
export function FlagOutlineIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth="1.5" aria-hidden="true">
      <path d="M5.75 13.25L5.75 5.75C5.75 5.75 8.5 3.5 12 5.75C15.5 8 18.25 5.75 18.25 5.75V13.25C18.25 13.25 15.5 15.5 12 13.25C8.5 11 5.75 13.25 5.75 13.25ZM5.75 13.25L5.75 19.25" />
    </svg>
  );
}

export function ChevronDownIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

// Filled lightning glyph — intentionally opts out of `base` (which is
// stroke-only) because the pre-flight checklist title icon reads as a
// solid amber bolt, matching the command-center reference.
export function ZapIcon({ size = 13 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  );
}

// Filled diamond — the milestone marker, matching the Scheduler's milestone
// glyph. Solid fill (opts out of stroke-only `base`); colour via `currentColor`.
export function MilestoneIcon({ size = 12 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <polygon points="12 2 22 12 12 22 2 12" />
    </svg>
  );
}

/** The schedule's three-bar Gantt mark — staggered filled bars. Marks
 *  something that came from a Scheduler task. */
export function GanttIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="1" y="2.5" width="8" height="2.6" rx="1.1" />
      <rect x="4" y="6.7" width="9" height="2.6" rx="1.1" />
      <rect x="7" y="10.9" width="8" height="2.6" rx="1.1" />
    </svg>
  );
}

/** A check on a filled disc — read-receipt marks; the disc takes currentColor, the check the surface. */
export function CheckCircleFilledIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true">
      <circle cx="12" cy="12" r="11" />
      <path d="m7.5 12.5 3 3 6-7" fill="none" stroke="var(--color-surface)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CheckCircleIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12 3 3 5-6" />
    </svg>
  );
}

// Message-rating thumbs (AI assistant answers). Stroke-only like the rest of
// this file; the "rated" state is painted by CSS (`fill: currentColor` on the
// svg overrides the presentation attribute from `base`) rather than by a
// second, filled icon.
export function ThumbUpIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M7 10v12" />
      <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
    </svg>
  );
}

export function ThumbDownIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M17 14V2" />
      <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
    </svg>
  );
}

/** The documents page's list ⇄ grid switch. */
export function ListViewIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M8 6h13" />
      <path d="M8 12h13" />
      <path d="M8 18h13" />
      <path d="M3 6h.01" />
      <path d="M3 12h.01" />
      <path d="M3 18h.01" />
    </svg>
  );
}

export function GridViewIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}

interface ILightbulbIconProps extends IIconProps {
  /** Override the shared 1.6 stroke — the page tour's bulb header draws it at
      22px, where a slightly heavier line keeps the filament shape readable. */
  strokeWidth?: number;
}

/** Lightbulb — the page tour's mark, on its bulb header and on the profile
    menu's "Page tour" item. One glyph, so the two always agree. */
export function LightbulbIcon({ size = 18, strokeWidth = base.strokeWidth }: ILightbulbIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={strokeWidth}>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 3a6.5 6.5 0 0 0-3.9 11.7c.6.5.9 1.1.9 1.8v.5h6v-.5c0-.7.3-1.3.9-1.8A6.5 6.5 0 0 0 12 3z" />
    </svg>
  );
}
